import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from "react-router-dom";

import AppContext from "../../app-context";
import { socketUseEffect } from "../../socket";

import PageTitle from "../core/page-title";

import SideBar from "../core/dashboards/sidebar";
import MainDashboardContent from "../core/dashboards/section"

import Dashboard from "./sub-pages/domains/dashboard";
import Generator from "./sub-pages/push/generator";
import { useAuth } from "../../AuthContext";
import { IconEdit, IconLayoutDashboard, IconPalette, IconPlug, IconTrash } from "@tabler/icons-react";
import Plugins from "./sub-pages/wordpress/plugins";
import Domains from "./domains";

// ---------- i18n ----------
const dict = {
    en: {
        loading: "Loading...",
        pageTitlePrefix: "Domains",
        subTitle: "Details",
        linkListName: "Domain Tests",

        tabDashboard: "Dashboard",
        tabEdit: "Edit",
        tabDelete: "Remove",

        sortStatus: "Status",
        sortName: "Name",
        sortCreated: "Created Date",
    },
    ru: {
        loading: "Загрузка...",
        pageTitlePrefix: "Домены",
        subTitle: "Детали",
        linkListName: "Проверки доменов",

        tabDashboard: "Дашборд",
        tabEdit: "Редактировать",
        tabDelete: "Удалить",

        sortStatus: "Статус",
        sortName: "Имя",
        sortCreated: "Дата создания",
    },
    ua: {
        loading: "Завантаження...",
        pageTitlePrefix: "Домени",
        subTitle: "Деталі",
        linkListName: "Тести доменів",

        tabDashboard: "Дашборд",
        tabEdit: "Редагувати",
        tabDelete: "Видалити",

        sortStatus: "Статус",
        sortName: "Назва",
        sortCreated: "Дата створення",
    },
};

const getInitialLang = () => (localStorage.getItem("lang") || "en").toLowerCase();

// ---------- component ----------
const DomainsDashboard = ({ lang: langProp, ...props }) => {
    const [details, setDetails] = useState({ domain_name: "Loading..." });
    const [logs, setLogs] = useState([]);
    const { id, page } = useParams();
    const [refresh, setRefresh] = useState(true);

    const lang = langProp || getInitialLang();
    const t = useMemo(() => dict[lang] || dict.en, [lang]);

    const { user } = useAuth();
    const listeners = [
        { name: "domains", fn: "get", args: { user_id: user.user_id, id: id }, saveDataFN: setDetails, row: "0" },
        { name: "domains", fn: "logs", args: { user_id: user.user_id, id: id }, saveDataFN: (res) => setLogs(res.data || []) },
    ];
    useEffect(() => socketUseEffect(listeners, user), [id, page, refresh]);

    const tabs = [
        { label: t.tabDashboard, page: "dashboard", link: "/domains/:id/dashboard", controller: Dashboard, args: { details, logs } },
        { label: t.tabEdit, page: "edit", link: "/domains/:id/edit", controller: Domains, args: { edit: 1, id, details, refresh, setRefresh } },
        { label: t.tabDelete, page: "delete", link: "/domains/:id/delete", controller: Domains, args: { delete: 1, id, details, refresh, setRefresh } },
    ];

    const icons = {
        dashboard: <IconLayoutDashboard size={20} />,
        edit: <IconEdit size={20} />,
        delete: <IconTrash size={20} />,
    };

    const sort = [
        { label: t.sortStatus, column: "status" },
        { label: t.sortName, column: "name" },
        { label: t.sortCreated, column: "created_date" },
    ];

    const titleText = (
        <>
            {t.pageTitlePrefix}:{" "}
            {details.domain_name === "Loading..." ? (
                <span className="loading-text">{t.loading}</span>
            ) : (
                details.domain_name
            )}
        </>
    );

    return (
        <>
            <PageTitle
                title={titleText}
                homeUrl={"/dashboard"}
                subTitle={t.subTitle}
                links={[{ name: t.linkListName, link: "/domains" }]}
                menuItems={tabs}
                menuIcons={icons}
                curPage={page}
                curID={id}
            />
            <div className={"card overflow-hidden invoice-application"}>
                <div className="d-flex">
                    <div className="w-25 d-none d-lg-block border-end user-chat-box">
                        <div className="app-invoice">
                            <ul className="overflow-auto invoice-users simplebar-scrollable-y" data-simplebar="init">
                                <div className="simplebar-wrapper" style={{ margin: "0px" }}>
                                    <div className="simplebar-height-auto-observer-wrapper">
                                        <div className="simplebar-height-auto-observer"></div>
                                    </div>
                                    <div className="simplebar-mask">
                                        <div className="simplebar-offset" style={{ right: "0px", bottom: "0px" }}>
                                            <div
                                                className="simplebar-content-wrapper"
                                                tabIndex="0"
                                                role="region"
                                                aria-label="scrollable content"
                                                style={{ height: "100%", overflow: "hidden scroll" }}
                                            >
                                                <div className="simplebar-content" style={{ padding: "0px" }}>
                                                    <SideBar
                                                        id={id}
                                                        sort={sort}
                                                        object={"domains"}
                                                        path={"domains"}
                                                        controller={Domains}
                                                        refresh={refresh}
                                                        setRefresh={setRefresh}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="simplebar-placeholder" style={{ width: "280px", height: "459px" }}></div>
                                </div>
                                <div className="simplebar-track simplebar-horizontal" style={{ visibility: "hidden" }}>
                                    <div className="simplebar-scrollbar" style={{ width: "0px", display: "none" }}></div>
                                </div>
                                <div className="simplebar-track simplebar-vertical" style={{ visibility: "visible" }}>
                                    <div
                                        className="simplebar-scrollbar"
                                        style={{ height: "25px", display: "block", transform: "translate3d(0px, 0px, 0px)" }}
                                    ></div>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div className="w-75 w-xs-100 chat-container">
                        <div className="invoice-inner-part h-100">
                            <div className="invoiceing-box">
                                <div id="custom-invoice">
                                    <MainDashboardContent tabs={tabs} page={page} id={id} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DomainsDashboard;
